import { useState } from 'react';
import { CartItemCustomization } from '../app/data/models/cart';
import MealItem from '../app/data/models/mealItem';
import { generateCartItemId } from '../features/customer/cart/cartHelper';

export const useCustomizations = (
  mealItem: MealItem,
  onQuantityChange: (
    cartItemId: string,
    modifiedQuantity: number,
    customizations?: CartItemCustomization[]
  ) => void
) => {
  const [showCustomizations, setShowCustomizations] = useState(false);

  const handleQuantityChange = (quantity: number) => {
    if (
      mealItem.customizations?.length &&
      mealItem.customizations?.length > 0
    ) {
      setShowCustomizations(true);
    } else {
      onQuantityChange(generateCartItemId(mealItem.id, []), quantity, []);
    }
  };

  const handleAddCustomizations = (
    customizations: CartItemCustomization[],
    cartItemId: string,
    quantity: number
  ) => {
    onQuantityChange(cartItemId, quantity, customizations);
    setShowCustomizations(false);
  };

  return {
    showCustomizations,
    setShowCustomizations,
    handleQuantityChange,
    handleAddCustomizations,
  };
};
